import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import type { GuardedFeature } from '@recruitee/feature-guard';
import { FeatureGuardMode, FeatureGuardDropdownItemComponent } from '@recruitee/feature-guard';
import type { IconName } from '@recruitee/user-interface';
import {
  BadgeComponent,
  HeadingComponent,
  IconComponent,
  DropdownItemComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-redactor-inserts-dropdown-item',
  templateUrl: 'redactor-inserts-dropdown-item.component.html',
  styleUrls: ['./redactor-inserts-dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FeatureGuardDropdownItemComponent,
    DropdownItemComponent,
    IconComponent,
    HeadingComponent,
    BadgeComponent,
  ],
})
export class RedactorInsertsDropdownItemComponent {
  @Input() public iconName: IconName;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public selected: boolean;
  @Input() public featureGuard: GuardedFeature;
  @Input() public badgeText?: string;

  public stepInside = output<MouseEvent>();

  public featureGuardMode: typeof FeatureGuardMode = FeatureGuardMode;
}
